/* eslint-disable */
export default {
  ringtones: 'Sonneries',
  incomingRingtone: 'Sonnerie d’appel entrant',
  outgoingRingtone: 'Sonnerie d’appel sortant',
  play: 'Lire',
  stop: 'Arrêter',
  upload: 'Importer',
  reset: 'Réinitialiser',
  save: 'Enregistrer',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
